import type { ModalActionHandler } from './modalActionTypes';
import { unassignJob } from '../map/settlement';
import { getSettlement } from './settlementActionUtils';

export const fireSmithAction: ModalActionHandler = (state, modal) => {
    const settlement = getSettlement(state, modal);
    if (!settlement || settlement.jobs.smiths <= 0) return false;
    if (!unassignJob(settlement, 'smiths')) return false;
    settlement.production.blacksmith.progress.pop();
    settlement.production.blacksmith.task.pop();
    return true;
};
